import React from "react";
import { Quote } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Reveal, Overline } from "@/components/Reveal";

const Testimonials = () => {
  const { t } = useSite();
  const tt = t.testimonials;

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative bg-card py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>{tt.overline}</Overline>
            <h2 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              {tt.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-3">
          {tt.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col border border-border bg-background p-8 transition-colors duration-500 hover:border-gold"
              >
                <Quote size={28} className="text-gold" />
                <blockquote className="mt-6 flex-1 font-heading text-xl font-light italic leading-relaxed text-foreground">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-8 border-t border-border pt-5">
                  <div className="font-body text-sm font-medium text-foreground">{item.name}</div>
                  <div className="font-body text-xs uppercase tracking-[0.12em] text-muted-foreground">
                    {item.role}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
